import { COLORS } from '@btime/constants'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { HorizontalLine } from '../../../../../../../components/shapes/Line'
import { Title } from '../../../../../../../packages/kiti/components/presentation/Text'
import { hasValue } from '../../../../../../../utils/helpers/value'
import { useChecklistFormActions, useSelectedQuestion } from '../../../../_form/ChecklistFormHandler'
import Select from '../../../../../../../packages/kiti/components/form/Select'
import Separator from '../../../../../../../packages/kiti/components/helpers/Separator'

const getLabelsOptions = t => [
  { id: undefined, name: t('labels.yesNo') },
  { id: { true: t('labels.compliant'), false: t('labels.nonCompliant') }, name: t('labels.compliantNonCompliant') },
  { id: { true: t('labels.approved'), false: t('labels.rejected') }, name: t('labels.approvedRejected') },
  { id: { true: t('labels.positive'), false: t('labels.negative') }, name: t('labels.positiveNegative') }
]

const BooleanSection = () => {
  const { t } = useTranslation('editChecklist')
  const { handleSelectedQuestionChangeOnPath } = useChecklistFormActions()
  const selectedQuestion = useSelectedQuestion()

  if (selectedQuestion?.questionType?.name !== 'checkbox') return false

  let selectedLabelId = selectedQuestion?.data?.labels
  if (hasValue(selectedLabelId)) {
    selectedLabelId = `${selectedLabelId.true}/${selectedLabelId.false}`
  }

  return (
    <>
      <Separator weight={6} />
      <Title size="h6" color={COLORS.dark4}>
        {t('labels')}
      </Title>
      <HorizontalLine thin lineColor={COLORS.light2} />
      <Separator weight={2} />

      <Select
        options={getLabelsOptions(t)}
        onChange={handleSelectedQuestionChangeOnPath(['data', 'labels'])}
        value={selectedLabelId}
        selectOnlyId
        disableEmptyOption
      />
    </>
  )
}

export default BooleanSection
